module.exports = __webpack_public_path__ + "img/tinder.aa545555.svg";